import React from 'react';
import './TestComponent.css';

const TestComponent = () => {
    return (
        <div className="test-container">
            <div className="test-item reveal-left in-view">Left Animation</div>
            <div className="test-item reveal-right in-view">Right Animation</div>
        </div>
    );
};

export default TestComponent;
